/*
 * Styled dialog shown when a fresh Plaid Link attempt fails (institution down,
 * unsupported, network error, etc.). Replaces the harsh `window.alert("Connection
 * failed: ...")` so the user gets actionable guidance instead of a chrome popup.
 */
import i18n.StringKey
import i18n.tr
import kotlinx.browser.document
import org.w3c.dom.HTMLElement

fun showConnectFailedDialog(detail: String? = null) {
    if (document.getElementById("connect-failed-overlay") != null) return
    val theme = WebTheme.current

    val overlay = document.createElement("div") as HTMLElement
    overlay.id = "connect-failed-overlay"
    overlay.style.cssText = """
        position: fixed; inset: 0;
        background: rgba(0,0,0,0.6);
        display: flex; align-items: center; justify-content: center;
        z-index: 10000;
    """

    val dialog = document.createElement("div") as HTMLElement
    dialog.style.cssText = """
        background: ${theme.card};
        border: 1px solid ${theme.border};
        border-radius: 12px;
        padding: 24px;
        min-width: 320px;
        max-width: 460px;
        box-shadow: 0 20px 60px rgba(0,0,0,0.4);
    """

    val title = document.createElement("div") as HTMLElement
    title.textContent = StringKey.CONNECT_FAILED_TITLE.tr()
    title.style.cssText = "font-size: 16px; font-weight: 600; color: ${theme.textPrimary}; margin-bottom: 8px;"
    dialog.appendChild(title)

    val body = document.createElement("div") as HTMLElement
    body.textContent = StringKey.CONNECT_FAILED_BODY.tr()
    body.style.cssText = "font-size: 14px; color: ${theme.textSecondary}; margin-bottom: 16px; line-height: 1.5;"
    dialog.appendChild(body)

    // Optional technical detail line — collapsed by default visually but readable.
    if (!detail.isNullOrBlank()) {
        val techDetail = document.createElement("div") as HTMLElement
        techDetail.textContent = detail
        techDetail.style.cssText = """
            font-size: 12px; color: ${theme.textSecondary};
            background: ${theme.background};
            border: 1px solid ${theme.border};
            border-radius: 6px;
            padding: 8px 10px;
            margin-bottom: 16px;
            font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
            word-break: break-word;
        """
        dialog.appendChild(techDetail)
    }

    val btnRow = document.createElement("div") as HTMLElement
    btnRow.style.cssText = "display: flex; justify-content: flex-end; gap: 8px;"

    val okBtn = document.createElement("button") as HTMLElement
    okBtn.textContent = StringKey.CONNECT_FAILED_DISMISS.tr()
    okBtn.style.cssText = """
        background: ${theme.accent};
        border: none;
        color: ${if (theme.isDark) "#000000" else "#FFFFFF"};
        font-size: 14px; font-weight: 600;
        padding: 8px 18px; border-radius: 8px;
        cursor: pointer;
    """
    okBtn.addEventListener("click", { overlay.remove() })
    btnRow.appendChild(okBtn)

    dialog.appendChild(btnRow)
    overlay.addEventListener("click", { e ->
        if (e.target == overlay) overlay.remove()
    })
    overlay.appendChild(dialog)
    document.body?.appendChild(overlay)
}
